export var EditorType;
(function (EditorType) {
    EditorType["Classic"] = "CLASSIC";
    EditorType["Responsive"] = "RESPONSIVE";
    EditorType["ADI"] = "ADI";
    EditorType["ADI_MA"] = "ADI_MA";
    EditorType["ADI_TEMPLATE"] = "ADI_TEMPLATE";
})(EditorType || (EditorType = {}));
export var EditorSubType;
(function (EditorSubType) {
    EditorSubType["EditorX"] = "EDITOR_X";
    EditorSubType["Studio"] = "STUDIO";
})(EditorSubType || (EditorSubType = {}));
export var InstallInitiator;
(function (InstallInitiator) {
    /**
     * Application was installed by a user action in the Editor.
     */
    InstallInitiator["Editor"] = "EDITOR";
    /**
     * Application was installed by another Application.
     */
    InstallInitiator["App"] = "APP";
    /**
     * Application was installed by dependency services defined on app market.
     */
    InstallInitiator["Dependency_Service"] = "Dependency_Service";
})(InstallInitiator || (InstallInitiator = {}));
export var InstallationOriginType;
(function (InstallationOriginType) {
    /**
     * Application was installed from the App Market.
     */
    InstallationOriginType["AppMarket"] = "APP_MARKET";
    /**
     * Application was installed from the Add Panel.
     */
    InstallationOriginType["AddPanel"] = "ADD_PANEL";
    /**
     * Application was installed from the Application Panel.
     */
    InstallationOriginType["AppPanel"] = "APP_PANEL";
    /**
     * Application was installed from the Pages Panel Settings Panel.
     */
    InstallationOriginType["PageSettingsPanel"] = "PAGE_SETTINGS_PANEL";
    /**
     * Application was installed by PAAS (Preset as a service).
     */
    InstallationOriginType["PresetService"] = "PRESET_SERVICE";
    /**
     * Application was installed by Site Creation - Widgets flow.
     */
    InstallationOriginType["SITE_CREATION"] = "SITE_CREATION";
    /**
     * Application was installed by Site Creation - Silent flow.
     */
    InstallationOriginType["SILENT_INSTALL_SITE_CREATION"] = "SILENT_INSTALL_SITE_CREATION";
    /**
     * Application was installed by Silent Installation service.
     */
    InstallationOriginType["SILENT_INSTALL"] = "SILENT_INSTALL";
    /**
     * Application was installed from the Add Section Panel.
     */
    InstallationOriginType["ADD_SECTION_PANEL"] = "ADD_SECTION_PANEL";
    /**
     * Application was installed from the Add Page Panel.
     */
    InstallationOriginType["ADD_PAGE_PANEL"] = "ADD_PAGE_PANEL";
    /**
     * Application was copy-pasted by the user.
     */
    InstallationOriginType["COPY_PASTE"] = "COPY_PASTE";
    /**
     * Application was installed from the Funnel service.
     */
    InstallationOriginType["INTRO_FUNNEL"] = "INTRO_FUNNEL";
    /**
     * Application was installed from the Pages panel.
     */
    InstallationOriginType["PAGES_PANEL"] = "PAGES_PANEL";
    /**
     * Application was installed from Pages panel settings.
     */
    InstallationOriginType["PAGE_SETTINGS_PANEL"] = "PAGE_SETTINGS_PANEL";
    /**
     * Application was installed from Velo import panel.
     */
    InstallationOriginType["IMPORT_PANEL"] = "IMPORT_PANEL";
    /**
     * Application was installed from editor My Business Panel.
     */
    InstallationOriginType["MY_BUSINESS"] = "MY_BUSINESS";
    /**
     * Application was installed from JS-SDK iframe sdk.
     */
    InstallationOriginType["IFRAME_JS_SDK"] = "IFRAME_JS_SDK";
})(InstallationOriginType || (InstallationOriginType = {}));
//# sourceMappingURL=origin.js.map